module.exports = __webpack_public_path__ + "static/img/bannerImg(2).0909c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bannerImg(2).jpg
// module id = EHbt
// module chunks = 1